export interface StaffNameRecord {
  userName?: string
}

export function filterGtStaffByName<T extends StaffNameRecord>(staff: T[], name: string): T[] {
  const keyword = name.trim().toLocaleLowerCase()
  if (!keyword) {
    return staff
  }
  return staff.filter((item) => String(item.userName ?? '').toLocaleLowerCase().includes(keyword))
}
